import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Admin.css";

const AdminLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // Hardcoded credentials (using simple base64 encoding instead of SHA-256)
  const ADMIN_USERNAME = "admin";
  // Password: admin123 (stored as base64)
  const ADMIN_PASSWORD_HASH = "YWRtaW4xMjM="; // base64 for "admin123"

  const handleLogin = (e) => {
    e.preventDefault();
    setError("");

    if (!username || !password) {
      setError("Please enter both username and password");
      return;
    }

    // Simple base64 encoding for password (works without async)
    const hashedPassword = btoa(password);

    if (username === ADMIN_USERNAME && hashedPassword === ADMIN_PASSWORD_HASH) {
      // Store login session
      localStorage.setItem("adminLoggedIn", "true");
      localStorage.setItem("adminUsername", username);
      navigate("/admin/dashboard");
    } else {
      setError("Invalid username or password");
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-box">
        <div className="admin-login-header">
          <h2>🔐 Admin Panel</h2>
          <p>Enter your credentials to access the dashboard</p>
        </div>
        <form onSubmit={handleLogin} className="admin-login-form">
          <div className="form-group">
            <label>Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
              className="form-input"
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              className="form-input"
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          <button type="submit" className="login-btn">Login</button>
        </form>
        <div className="admin-login-footer">
          <p>Default: admin / admin123</p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;